var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import ModalPdf from './ModalPdf';
import { FormBaseElement, } from '@unitarius/xbpm-runtime';
import PagePdf from './PagePdf';
var PdfControl = /** @class */ (function (_super) {
    __extends(PdfControl, _super);
    function PdfControl(props) {
        var _this = _super.call(this, props) || this;
        _this.state = __assign(__assign({}, _this.state), { isVisibleModal: false });
        return _this;
    }
    PdfControl.prototype.elementRender = function (def) {
        var frontOptions = def.frontOptions;
        var _a = frontOptions.isVisibleModal, isVisibleModal = _a === void 0 ? false : _a;
        if (def.hidden) {
            return null;
        }
        return isVisibleModal ? (React.createElement(ModalPdf, { error: this.error, touched: this.touched, label: def.label, value: this.value, frontOptions: frontOptions })) : (React.createElement(PagePdf, { value: this.value, frontOptions: frontOptions }));
    };
    return PdfControl;
}(FormBaseElement));
export { PdfControl };
//# sourceMappingURL=index.js.map